import React from "react";
import { useState, useEffect } from "react";
import { Spinner, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { vehicle_type_option } from "../../utilities";
import Select from "react-select";
import { createServiceApi, updateServiceApi } from "../../services/ServiceApi";
const AddServiceModal = ({ visible, onClose, onAfterSubmit, data = null }) => {
  const [loading, setLoading] = useState(false);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [form, setForm] = useState({
    name: "",
    vehicle_type: "",
    price: "",
  });
  const [error, setError] = useState({});
  useEffect(() => {
    if (visible) {
      handleReset();
    }
  }, [visible]);

  const handleReset = () => {
    if (data) {
      setForm({
        ...form,
        name: data?.name || "",
        price: Number(data?.price || "") || "",
      });
      setSelectedVehicle(
        vehicle_type_option.find((item) => item?.value == data?.vehicle_type) ||
          null
      );
    } else {
      setForm({
        name: "",
        vehicle_type: "",
        price: "",
      });
      setSelectedVehicle(null);
    }

    setError({});
  };

  useEffect(() => {
    setForm({ ...form, vehicle_type: selectedVehicle?.value || "" });
    if (error?.vehicle_type && selectedVehicle?.value) {
      setError({ ...error, vehicle_type: "" });
    }
  }, [selectedVehicle]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    if (value && error[name]) {
      setError({ ...error, [name]: "" });
    }
  };

  const addService = () => {
    setLoading(true);
    createServiceApi(form)
      .then((res) => {
        toast.success("Service Created Successfully");
        onAfterSubmit();
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const updateService = () => {
    setLoading(true);
    updateServiceApi(data?.id || "", form)
      .then((res) => {
        toast.success("Service Update Successfully");
        onAfterSubmit();
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleSubmit = () => {
    let error = {};
    if (!form?.name) {
      error.name = "Name Required";
    }
    if (!form?.price) {
      error.price = "Price Required";
    }
    if (!form?.vehicle_type) {
      error.vehicle_type = "Vehice Required";
    }

    setError(error);
    if (Object.entries(error).length == 0) {
      if (data) {
        updateService();
      } else {
        addService();
      }
    }
  };
  return (
    <div>
      <Modal show={visible} onHide={onClose}>
        <Modal.Header>
          <Modal.Title>{data ? "Update Service" : "Add Service"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="p-2">
            <div className="mb-2">
              <label className="form-label text-dark">Service Name</label>
              <input
                type="text"
                className={`form-control ${error?.name ? "is-invalid" : ""}`}
                name="name"
                value={form?.name}
                placeholder="Service 1"
                onChange={handleInputChange}
              />
              {error?.name && (
                <small className="text-danger">{error?.name}</small>
              )}
            </div>
            <div className="mb-2 row gx-2">
              <div className="col-md-6">
                <label className="form-label text-dark">Vehicle</label>
                <Select
                  classNamePrefix="select"
                  className="react-select"
                  placeholder="Select Vehicle"
                  options={vehicle_type_option}
                  value={selectedVehicle}
                  onChange={setSelectedVehicle}
                />
                {error?.vehicle_type && (
                  <small className="text-danger">{error?.vehicle_type}</small>
                )}
              </div>
              <div className="col-md-6">
                <label className="form-label text-dark">Price</label>
                <input
                  type="text"
                  name="price"
                  className={`form-control ${error?.price ? "is-invalid" : ""}`}
                  value={form?.price}
                  placeholder="1200"
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*$/.test(value)) {
                      handleInputChange(e);
                    }
                  }}
                />
                {error?.price && (
                  <small className="text-danger">{error?.price}</small>
                )}
              </div>
            </div>

            <code className="text-light">
              <strong>Note:</strong> Please ensure all fields are correctly
              filled. - Service Name should be clear and specific. - Vehicle
              type must match the type of service offered. - Price should be a
              valid numeric value without symbols.
            </code>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-end gap-2 w-100">
            <span
              className="btn btn-outline-dark"
              disabled={loading}
              onClick={onClose}
            >
              Cancel
            </span>
            <button
              className="btn btn-primary"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading && (
                <Spinner
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              )}
              {data ? "Update" : "Submit"}
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AddServiceModal;
